export const HEADER_API_VERSION = 'api-version'
export const HEADER_AUTHORIZATION = 'Authorization'
export const HEADER_CONTENT_TYPE = 'Content-Type'
export const HEADER_ORG_ID = 'org-id'
export const HEADER_TIMEZONE = 'timezone'
export const HEADER_PUSH_CLIENT_ID = 'x-push-client-id'
